import request from '@/config/axios'

/**
 * ⚠️ 平台管理端 — 店铺管理 API
 * 注意：这不是商家端的店铺管理 API（商家端见 shop.ts）
 * 本文件使用 request（/admin-api 前缀），用于平台管理员管理所有商家店铺
 */

// 获取店铺分页列表
export function getShopPage(params: any) {
  return request.get({ url: '/merchant/shop/page', params })
}

// 获取店铺详情
export function getShop(id: number) {
  return request.get({ url: '/merchant/shop/get', params: { id } })
}

// 新增平台自营店铺
export function createSelfOperatedShop(data: {
  shopName: string
  shopLogo?: string
  shopBanner?: string
  shopDesc?: string
  contactPhone?: string
}) {
  return request.post({ url: '/merchant/shop/create-self-operated', data })
}

// 更新店铺状态
export function updateShopStatus(data: { id: number; status: number }) {
  return request.put({ url: '/merchant/shop/update-status', data })
}

// 更新店铺类型（0 第三方 / 1 自营 / 2 O2O壳 / 3 酒店）
export function updateShopType(data: { id: number; shopType: number }) {
  return request.put({ url: '/merchant/shop/update-type', data })
}

/** 更新店铺形象：Logo / Banner / 简介 / 退货地址等 */
export function updateShopProfile(data: {
  id: number
  shopName?: string
  shopLogo?: string
  shopBanner?: string
  shopDesc?: string
  contactPhone?: string
  returnName: string
  returnMobile: string
  returnAreaId: number
  returnDetailAddress: string
  longitude?: number
  latitude?: number
}) {
  return request.put({ url: '/merchant/shop/update-profile', data })
}

// 店铺精简列表（id + name + shopType）；可选 shopType / merchantId 过滤
export function getShopSimpleList(params?: { shopType?: number; merchantId?: number }) {
  return request.get({ url: '/merchant/shop/simple-list', params })
}
